import { Routes } from '@angular/router';
import { askUnsavedChangesGuard } from './guards/ask-unsaved-changes.guard';

export const storageLocationRoutes: Routes = [
  {
    path: 'storage-location',
    children: [
      {
        path: 'select',
        loadComponent: () =>
          import('./pages/select-storage-location/select-storage-location.component'),
      },
      {
        path: ':id/product-search',
        loadComponent: () => import('./pages/product-search/product-search.component'),
      },
      {
        path: ':id/products/:productId',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/edit-article-item/edit-article-item.component'),
        canDeactivate: [askUnsavedChangesGuard],
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/storage-articles-list/storage-articles-list.component'),
      },
      {
        path: '**',
        redirectTo: '/storage-location/select',
      },
    ],
  },
];
